import React from "react";
import QuestionnaireStart from "./QuestionnaireStart";
import ManagementFlow from "../questionFlows/ManagementFlow";
import ClinicalToolFlow from "../questionFlows/ClinicalToolFlow";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/nav.scss";

const w = window;

class MainTabView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstPage: w[this.firstPageKey()],
      flowCategory: "",
      title: "",
      pdf: w[this.pdfKey()],
    };

    this.beginFlow = this.beginFlow.bind(this);
    this.flowView = this.flowView.bind(this);
    this.restart = this.restart.bind(this);
    this.handleButton = this.handleButton.bind(this);
  }

  firstPageKey() {
    return this.props.id + "_first_page";
  }

  pdfKey() {
    return this.props.id + "_pdf";
  }

  categoryKey() {
    return this.props.id + "_category";
  }

  beginFlow(category, title) {
    w.history.pushState({category:category, title: title}, null);
    w[this.firstPageKey()] = false;
    w[this.categoryKey()] = category;
    this.setState({
      firstPage: false,
      flowCategory: category,
      title: title,
    });
    window.scrollTo({
      top: 0,
    });
  }

  restart() {
    w[this.firstPageKey()] = true;
    this.setState({ firstPage: true, flowCategory: "", title: "", pdf: "" });
  }

  handleButton(action, section) {
    if (action == "handout_english") {
      action = "English V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL";
    } else if (action == "handout_spanish") {
      action = "Spanish V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL";
    }

    if (section === "Clinical Guidelines") {
      w.open(action, "_blank");
    } else if (action.includes("http")) {
      w.open(action, "_blank");
    } else if (action == "cows_tool" || action == "dsm_oud" || action == "audit_c" || action == "medications_assist" || action == "references") {
      this.props.confirmationTool({
        target: {
          id: action
        }
      });
    } else {
      const pdf = require("../figures/" + action + ".pdf");
      w.open(pdf, "_blank");
    }
  }

  cardView() {
    return (
      <QuestionnaireStart
        makeSelection={this.beginFlow}
        selectionGroup={this.props.id}
        cardClass={this.props.cardClass}
        handleButton={this.handleButton}
        sectionColor={this.props.color}
        buttonImage={this.props.buttonImage}
      />
    );
  }

  flowView() {
    let cat = this.state.flowCategory;
    let title = this.state.title;
    if (w[this.categoryKey()] && w[this.categoryKey()] !== "") {
      cat = w[this.categoryKey()];
      if (cat == "dsm_oud") {
        title = "DSM-5 Criteria for Diagnosis of Opioid Use Disorder";
      } else if (cat == "audit_c") {
        title = "AUDIT-C for Alcohol Use";
      }
    }

    return {
      management: (
        <ManagementFlow
          category={cat}
          title={title}
          restart={this.restart}
          color={this.props.color}
          handleButton={this.handleButton}
          confirmationTool={this.props.confirmationTool}
        />
      ),
      tools: (
        <ClinicalToolFlow
          category={cat}
          title={title}
          color={this.props.color}
          restart={this.restart}
        />
      ),
    };
  }

  componentWillReceiveProps() {
    this.setState({ firstPage: w[this.firstPageKey()], pdf: w[this.pdfKey()] });
  }

  render() {
    if (typeof w["management_first_page"] === "undefined") {
      w["management_first_page"] = true;
      w["management_pdf"] = "";
      w["management_category"] = "";
      w["tools_pdf"] = "";
      w["tools_category"] = this.props.clinicalTool;
    }

    const firstPage =
      this.state.firstPage === w[this.firstPageKey()]
        ? this.state.firstPage
        : w[this.firstPageKey()];

    return (
      <div className="tab-content" id="nav-tabContent">
        <div
          id={this.props.id}
          role="tabpanel"
          aria-labelledby={"nav-" + this.props.id + "-tab"}
        ></div>
        {firstPage != false 
          ? this.cardView()
          : this.flowView()[this.props.id]}
      </div>
    );
  }
}

export default MainTabView;
